var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.job) ? _c('div', {
    staticClass: "well page"
  }, [_c('div', {
    staticClass: "row",
    attrs: {
      "id": "printReview"
    }
  }, [_c('h2', [_vm._v("Submitted Request")]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "showMsg"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "floorplan-img",
    attrs: {
      "src": '/dashboard/jobs/image/' + _vm.job.id + '/'
    }
  }), _vm._v(" "), _c('p', [_vm._v("This report documents the issues outlined below for your "), _c('b', [_vm._v(_vm._s(_vm.store.name))]), _vm._v(" store.")]), _vm._v(" "), (_vm.job.urgent) ? _c('b', [_vm._v("You have chosen to have this request completed ASAP!")]) : _vm._e(), _vm._v(" "), (!_vm.job.urgent) ? _c('p', [_vm._v("You have chosen to have this request completed in "), _c('b', [_vm._v(_vm._s(_vm.job.urgency_days))]), _vm._v(" days.")]) : _vm._e(), _vm._v(" "), (_vm.issues.length > 0) ? _c('h3', [_vm._v("Request Summary")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.issues), function(issue) {
    return _c('div', {
      staticClass: "col-xs-12"
    }, [_c('div', {
      staticClass: "panel panel-default"
    }, [_c('div', {
      staticClass: "panel-body"
    }, [_c('b', [_vm._v("Type: " + _vm._s(_vm.issue_type_name(issue.type)))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('i', {
      staticClass: "description"
    }, [_vm._v("Description: " + _vm._s(issue.description))]), _vm._v(" "), _c('br'), _vm._v(" "), _vm._l((_vm.issue_images(issue)), function(image) {
      return _c('div', {
        staticStyle: {
          "display": "inline"
        }
      }, [_c('i', {
        staticClass: "glyphicon glyphicon-picture",
        staticStyle: {
          "cursor": "pointer"
        },
        on: {
          "click": function($event) {
            _vm.view_image(image)
          }
        }
      }), _vm._v(" \n          ")])
    }), _vm._v(" "), (!_vm.issue_images(issue).length) ? _c('br') : _vm._e()], 2)])])
  })], 2), _vm._v(" "), (_vm.selected_photo) ? _c('modal', {
    attrs: {
      "title": "View Issue Image",
      "size": "lg"
    },
    on: {
      "hide": _vm.modal_closed
    },
    model: {
      value: (_vm.modal_open),
      callback: function($$v) {
        _vm.modal_open = $$v
      },
      expression: "modal_open"
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.selected_photo.image
    }
  })]) : _vm._e()], 1) : _vm._e()
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-84345af2","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./assets/vue/logger/JobPost.vue
// module id = 516
// module chunks = 0